import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

/**
 * A small "related surface" link placed near a page's heading, connecting two
 * admin surfaces that belong to one task flow (e.g. configuring a workspace and
 * editing its taxonomy, or editing a user and managing their workspace access).
 * Presentational and tenant-neutral, so it drops into both the Ant and dashai
 * (shadcn) pages unchanged.
 */
const RelatedPageLink = ({ to, children, className = "" }) => (
  <Link
    to={to}
    className={`inline-flex items-center gap-1 text-[13px] font-medium text-[#0E49B5] hover:underline ${className}`}
  >
    {children}
    <ArrowRight className="h-3.5 w-3.5" />
  </Link>
);

export default RelatedPageLink;
